import {Accordion, AccordionContent, AccordionItem, AccordionTrigger} from 'alm-react-components';
import parse from 'html-react-parser';
import getLocalizedContent from '../../lib/getLocalizedMetaData';
import {Tag} from '../../assets/constants/constants';

export const Curriculum = ({accordianData}: {accordianData: any}) => {
  return (
    <>
      {accordianData.map((res: any, index: number) => {
        const content = getLocalizedContent(res?.attributes?.localizedMetadata);
        return res?.attributes?.tags?.includes(Tag.doNotShow) ? null : (
          <div key={`lear-${index}`}>
            <Accordion type="single" collapsible className="w-full  mt-1">
              <AccordionItem value="item-1" className="border-0">
                <AccordionTrigger className="mb-3 bg-[#212930] px-4 rounded-lg program-accordion commitment-accordion text-base font-barlowLight py-3 hover:no-underline">
                  {content?.name}
                </AccordionTrigger>
                <AccordionContent className="text-base font-barlowLight ms-12 ql-editor text-white">
                  {content?.richTextOverview ? parse(content?.richTextOverview) : null}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        );
      })}
    </>
  );
};
